module.exports = __webpack_public_path__ + "images/shimo/slide-new-add18677d72e3a49ec0bea539f22a0bb.png";